import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathControlEmailTemplates(templateId=null) {
  if (templateId) {
      return `control/email-templates/${templateId}`;
  } else {
      return `control/email-templates`;
  }
}

export function createControlEmailTemplates(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlEmailTemplates(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlEmailTemplates(successCallback, errorCallback, data, templateId) {
  patchAuth({
    "path": pathControlEmailTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlEmailTemplates(successCallback, errorCallback, templateId) {
  deleteAuth({
    "path": pathControlEmailTemplates(templateId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderControlEmailTemplates(successCallback, errorCallback, data, templateId) {
  postAuth({
    "path": `control/email-templates/${templateId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewControlManageEmailTemplates(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-email-templates`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewControlEmailTemplateEditor(templateId=null) {
  if (templateId) {
      return `view/control/email-template-editor/${templateId}`;
  } else {
      return `view/control/email-template-editor`;
  }
}

export function getViewControlEmailTemplateEditor(successCallback, errorCallback, templateId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewControlEmailTemplateEditor(templateId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


